module.exports = __webpack_public_path__ + "static/media/kyra.bf0b3a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/kyra.jpg
// module id = 744
// module chunks = 0